import { FC } from "react";
import { Button } from "react-bootstrap";
import Icon from "../Icon";

import styles from "./rlcard.module.scss";

type Props = {
  page: number;
  totalPages: number;
  onPageChange: (newPage: number) => void;
};

const RLCardHeaderPagination: FC<Props> = ({
  page,
  totalPages,
  onPageChange
}) => (
  <div className={styles.rlcard_header_pagination}>
    <Button
      className={styles.rlcard_header_pagination_button}
      onClick={() => onPageChange(page - 1)}
      disabled={page === 1}
    >
      <Icon name="chevron-left" className={styles.pagination_icon} />
    </Button>
    <span className={styles.pagination_text}>
      <span className={styles.pagination_current_page}>{page}</span> of{" "}
      {totalPages}
    </span>
    <Button
      className={styles.rlcard_header_pagination_button}
      onClick={() => onPageChange(page + 1)}
      disabled={page === totalPages}
    >
      <Icon name="chevron-right" className={styles.pagination_icon} />
    </Button>
  </div>
);

export default RLCardHeaderPagination;
